import React from 'react';
import * as R from 'ramda';
import {mapWithIndex} from '@/util';
import {Identity} from 'monet';
import {LocaleLink} from '@/routes';
import {lookup} from '@/i18n';

import {codeMapping} from '@/config';
import PlanCategory from '@/b2c/PlanDetail/PlanCategoryList/PlanCategory';

const indexOfCodeMapKeys = codeMap => ([code]) =>
  R.indexOf(code, R.keys(codeMap));

const toPlanCategory = (codeMap, colorMap) => ([code, plans]) => {
  const title = lookup('product_type', code);
  const color = R.prop(code, colorMap);

  return (
    <PlanCategory key={title} category={title} color={color} plans={plans} />
  );
};

const PlanCategoryList = ({plans}) => {
  const codeMap = codeMapping('plan_record_type');
  const colorMap = codeMapping('plan_record_type_color');

  const list = Identity(plans)
    .map(R.groupBy(R.prop('productCategory')))
    .map(R.toPairs)
    .map(R.sortBy(indexOfCodeMapKeys(codeMap)))
    .map(R.map(toPlanCategory(codeMap, colorMap)));

  return <>{list}</>;
};

const PlanCategoryListRwd = ({currentPlan, plans}) => (
  <div className='select'>
    <div>
      <p>{lookup('product_type', currentPlan.productCategory)}</p>
      <small>
        {currentPlan.planNo} - {currentPlan.productName}
      </small>
    </div>
    <i className='material-icons'>keyboard_arrow_down</i>
    <ul>
      {mapWithIndex((plan, idx) => (
        <li key={idx}>
          {lookup('product_type', plan.productCategory)}
          <br />
          <LocaleLink to={`/b2c/plan_detail/${plan.id}`}>
            <small>{plan.planNo}</small> - {plan.productName}
          </LocaleLink>
        </li>
      ))(plans)}
    </ul>
  </div>
);

export {PlanCategoryList, PlanCategoryListRwd};
